<template>
  <div class="related-articles">
    <div class="related-articles-intro">
      <h2
        v-if="relatedArticleTitle"
        class="related-articles-title"
      >
        {{ relatedArticleTitle }}
      </h2>
      <p
        v-if="relatedArticleDescription"
        class="related-articles-description"
      >
        {{ relatedArticleDescription }}
      </p>
    </div>
    <kf-related-articles-item
      v-for="(article, i) in relatedArticles"
      :key="i"
      :article="article"
    />
    <kf-button-container
      :button-container-position-horizontal="true"
      :button-container-links="relatedLinks"
    />
  </div>
</template>

<script>
import KfRelatedArticlesItem from '@/components/related-articles/RelatedArticlesItem';
import KfButtonContainer from '@/components/button-container/ButtonContainer';

export default {
  name: 'KfRelatedArticles',
  components: {
    KfRelatedArticlesItem,
    KfButtonContainer,
  },
  props: {
    relatedArticleTitle: {
      type: String,
      default: null,
    },
    relatedArticleDescription: {
      type: String,
      default: null,
    },
    relatedArticles: {
      type: Array,
      default: null,
    },
    relatedLinks: {
      type: Array,
      default: null,
    }
  },
};
</script>

<style lang="postcss">
.related-articles {
  @apply flex flex-col;

  &-intro {
    @apply mb-10;

    @screen md {
      @apply mb-14;
    }

    & *:last-child {
      @apply mb-0;
    }
  }
}
</style>
